import { Route } from 'vue-router';
import { DEVICE } from '@/define/Adapter';

export default [{
  path: '/course',
  name: 'Course',
  component: () => import(/* webpackChunkName: "course" */ '../views/course/Index.vue'),
  redirect: { name: 'Course.FreedomVideo' },
  meta: {
    title: '已购内容',
  },
  children: [
    {
      path: '/course/detail/:id',
      name: 'Course.Detail',
      component: () => import(/* webpackChunkName: "course.detail" */ '../views/course/Detail.vue'),
      props: (route: Route) => ({
        courseId: Number(route.params.courseId),
      }),
      meta: {
        title: '课程目录',
        needLogin: true,
      },
    },
    {
      path: '/course/freedomVideo',
      name: 'Course.FreedomVideo',
      component: () => import(/* webpackChunkName: "course.freedomVideo" */ '../views/course/FreedomVideo.vue'),
      props: (route: Route) => ({
        unitId: Number(route.query.unitId),
        courseId: Number(route.query.courseId),
      }),
      meta: {
        title: '有道卡搭编程互动视频',
        needLogin: true,
      },
    },
    {
      path: '/course/freedomVideoPreview',
      name: 'Course.FreedomVideoPreview',
      component: () => import(/* webpackChunkName: "course.freedomVideo" */ '../views/course/FreedomVideoPreview.vue'),
      props: (route: Route) => ({
        unitId: Number(route.query.unitId),
      }),
      meta: {
        title: '有道卡搭编程互动视频预览',
        needLogin: true,
      },
    },
    {
      path: '/course/live',
      name: 'Course.live',
      component: () => import(/* webpackChunkName: "course.live" */ '../views/course/Live.vue'),
      props: (route: Route) => ({
        unitId: Number(route.query.unitId),
        courseId: Number(route.query.courseId),
        roomId: Number(route.query.roomId),
      }),
      meta: {
        title: '有道卡搭课程直播',
        needLogin: true,
      },
    },
    {
      path: '/course/report',
      name: 'Course.Report',
      component: () => import(/* webpackChunkName: "course.report" */ '../views/course/Report.vue'),
      props: (route: Route) => ({
        chapterId: Number(route.query.chapterId),
      }),
      meta: {
        title: '学习报告',
        needLogin: true,
      },
    },
    {
      path: '/course/reportPoster',
      name: 'Course.ReportPoster',
      component: () => import(/* webpackChunkName: "course.reportPoster" */ '../views/course/ReportPoster.vue'),
      props: (route: Route) => ({
        chapterId: Number(route.query.chapterId),
        uid: Number(route.query.uid),
      }),
      meta: {
        title: '学习报告',
        needLogin: true,
      },
    },
    {
      path: '/course/reportDaily',
      name: 'Course.ReportDaily',
      component: () => import(/* webpackChunkName: "course.reportDaily" */ '../views/course/ReportPosterDaily.vue'),
      props: (route: Route) => ({
        uid: Number(route.query.uid),
      }),
      meta: {
        title: '学习报告',
        needLogin: true,
      },
    },
    {
      path: '/course/goods/:id',
      name: 'Course.Goods',
      component: () => import(/* webpackChunkName: "course.goods" */ '../views/course/GoodsIndex.vue'),
      meta: {
        title: '课程商品页',
        needLogin: false,
        adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
      },
      children: [
        {
          path: '/course/goods/:id/mobile',
          name: `Course.Goods.${DEVICE.Mobile}`,
          component: () => import(/* webpackChunkName: "course.goods.mobile" */ '../views/course/GoodsMobile.vue'),
          props: (route: Route) => ({
            courseId: Number(route.params.id),
          }),
          meta: {
            title: '课程商品页',
          },
        },
        {
          path: '/course/goods/:id/pc',
          name: `Course.Goods.${DEVICE.PC}`,
          component: () => import(/* webpackChunkName: "course.goods.pc" */ '../views/course/GoodsPC.vue'),
          props: (route: Route) => ({
            courseId: Number(route.params.id),
          }),
          meta: {
            title: '课程商品页',
          },
        },
      ],
    },
    {
      path: '/course/guide',
      name: 'Course.Guide',
      component: () => import(/* webpackChunkName: "course.guide" */ '../views/course/Guide.vue'),
      props: (route: Route) => ({
        courseId: Number(route.query.courseId),
      }),
      meta: {
        title: '学习指导',
        needLogin: true,
      },
    },
    {
      path: '/course/editStudyPlan',
      name: 'Course.EditStudyPlan',
      component: () => import(/* webpackChunkName: "course.editStudyPlan" */ '../views/course/EditStudyPlan.vue'),
      props: (route: Route) => ({
        courseId: Number(route.query.courseId),
      }),
      meta: {
        title: '修改学习计划',
        needLogin: true,
      },
    },
    {
      path: '/course/selectPeriod/:id',
      name: 'Course.SelectPeriod',
      component: () => import(/* webpackChunkName: "course.selectPeriod" */ '../views/course/SelectPeriod.vue'),
      meta: {
        title: '直播课时间',
        needLogin: true,
      },
      props: (route: Route) => ({
        courseId: Number(route.params.id),
      }),
    },
  ],
}];
